/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Complete_SetInputs */

const en_val_complete_set = /** @type {(inputs: Val_Complete_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete Set`)
};

const es_val_complete_set = /** @type {(inputs: Val_Complete_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colección completa`)
};

const fr_val_complete_set = /** @type {(inputs: Val_Complete_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensemble complet`)
};

const de_val_complete_set = /** @type {(inputs: Val_Complete_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komplettes Set`)
};

const ja_val_complete_set = /** @type {(inputs: Val_Complete_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンプリートセット`)
};

const zh_val_complete_set = /** @type {(inputs: Val_Complete_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整套装`)
};

const ar_val_complete_set = /** @type {(inputs: Val_Complete_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجموعة كاملة`)
};

const id_val_complete_set = /** @type {(inputs: Val_Complete_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Lengkap`)
};

const it_val_complete_set = /** @type {(inputs: Val_Complete_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Completo`)
};

const ru_val_complete_set = /** @type {(inputs: Val_Complete_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полный набор`)
};

const pt_val_complete_set = /** @type {(inputs: Val_Complete_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjunto Completo`)
};

const ko_val_complete_set = /** @type {(inputs: Val_Complete_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`컴플리트 세트`)
};

/**
* | output |
* | --- |
* | "Complete Set" |
*
* @param {Val_Complete_SetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_complete_set = /** @type {((inputs?: Val_Complete_SetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Complete_SetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_complete_set(inputs)
	if (locale === "es") return es_val_complete_set(inputs)
	if (locale === "fr") return fr_val_complete_set(inputs)
	if (locale === "de") return de_val_complete_set(inputs)
	if (locale === "ja") return ja_val_complete_set(inputs)
	if (locale === "zh") return zh_val_complete_set(inputs)
	if (locale === "ar") return ar_val_complete_set(inputs)
	if (locale === "id") return id_val_complete_set(inputs)
	if (locale === "it") return it_val_complete_set(inputs)
	if (locale === "ru") return ru_val_complete_set(inputs)
	if (locale === "pt") return pt_val_complete_set(inputs)
	return ko_val_complete_set(inputs)
});